// @flow
import * as React from 'react';
import { Typography } from '@mui/material';
import { useAgentCallAgenda } from '../../../shared';

export const AgentNotLicensedInClientStateNotification = ({clientState}: {clientState?: string | null}) => {
  const {licensedStates} = useAgentCallAgenda();

  if (!clientState || !licensedStates.length || licensedStates.includes(clientState)) {
    return null;
  }

  return (
    <Typography align={'center'} color={'#fff'}
                sx={{background: 'linear-gradient(90deg, rgb(40 140 243) 0%, rgb(89 40 243) 100%)',
                  borderRadius: 1,
                  px: 4,
                  animation: 'blink 5s infinite',
                  '@keyframes blink': {
                    '0%, 100%': {
                      opacity: 1,
                    },
                    '50%': {
                      opacity: 0.8,
                    },
                  },

                  py: .5}} variant={'body2'}>
      You are not licensed in the client’s state.
    </Typography>
  );
};
